import script from "./AIOrderTaskWindow.vue?vue&type=script&lang=tsx&setup=true"
export * from "./AIOrderTaskWindow.vue?vue&type=script&lang=tsx&setup=true"

import "./AIOrderTaskWindow.vue?vue&type=style&index=0&id=28a52e3f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28a52e3f"]])

export default __exports__